import { Component, Input, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { MatDialog } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "../../shared/toastr.service";
import { Image } from "../media.interface";
import { ChangeImageAction, RemoveImageAction } from "../images.actions";
import { ConfirmationDialogComponent } from "../../shared/confirmation-dialog/confirmation-dialog.component";
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { ShowOnSubmitAttemptErrorStateMatcher } from "../../shared/error-state-matcher";
import { mediaFilePreview } from "../../shared/utils/media-file-preview.util";

@Component({
  selector: "app-image",
  templateUrl: "./image.component.html",
  styleUrls: ["./image.component.scss"],
  standalone: false,
})
export class ImageComponent implements OnInit {
  @Input() image: Image;
  form: UntypedFormGroup;
  editMode = false;
  errorStateMatcher = new ShowOnSubmitAttemptErrorStateMatcher();

  get filePreview() {
    return mediaFilePreview(this.image?.imageUrl);
  }

  constructor(
    private store: Store,
    private dialog: MatDialog,
    private translate: TranslateService,
    private toastr: ToastrService,
  ) {}

  ngOnInit(): void {
    this.fillInitialForm();
  }

  fillInitialForm = () => {
    this.form = new UntypedFormGroup({
      imageId: new UntypedFormControl(this.image.imageId, (control) =>
        Validators.required(control),
      ),
      name: new UntypedFormControl(this.image.name, (control) =>
        Validators.required(control),
      ),
    });
  };

  changeImage = () => {
    this.errorStateMatcher.submitAttempted = true;
    if (this.form.invalid) {
      return;
    }
    this.store.dispatch(
      new ChangeImageAction(
        this.form.value as { imageId: string; name: string },
      ),
    );
    this.changeEditMode();
  };

  cancelEditImage = () => {
    this.fillInitialForm();
    this.changeEditMode();
  };

  changeEditMode = () => {
    this.editMode = !this.editMode;
  };

  copyImageUrlToClipboard = () => {
    void navigator.clipboard.writeText(this.image.imageUrl);
    this.toastr.success(
      this.translate.instant("media.images.copyUrlSuccess") as string,
    );
  };

  removeImage = (imageId: string) => {
    this.dialog
      .open(ConfirmationDialogComponent, {
        data: {
          title: this.translate.instant(
            "media.images.deleteConfirmationText",
          ) as string,
        },
      })
      .afterClosed()
      .subscribe((confirm) => {
        if (confirm) {
          this.store.dispatch(new RemoveImageAction(imageId));
        }
      });
  };
}
